module.exports = __webpack_public_path__ + "static/media/student exclusion record.034f4722.svg";